// Single source of truth for business facts shown on the site.
// Change things here, not inside components.

export const BUSINESS = {
  name: 'Bubbles & Bark',
  tagline: 'Premium Pet Spa & Bakery',
  phone: '(407) 868-8608',
  phoneHref: 'tel:+14078688608',
  email: 'info@bubblesbark.com',
  address: '12188 Lake Underhill Rd, Orlando, FL 32825',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Bubbles+%26+Bark+12188+Lake+Underhill+Rd+Orlando+FL+32825',
  hours: [
    { days: 'Monday – Friday', time: '9:00 AM – 5:00 PM' },
    { days: 'Saturday', time: '9:00 AM – 6:00 PM' },
    { days: 'Sunday', time: '10:00 AM – 3:00 PM' },
  ],
};

export const SERVICES = [
  {
    key: 'full-spa',
    name: 'Full Spa',
    icon: 'Sparkles',
    gradient: 'from-pink-500 to-rose-400',
    blurb: 'Our most complete package — styled haircut, luxurious bath and every finishing touch.',
    includes: [
      'All over grooming with styled haircut',
      'Face shaping',
      'Sanitary regions cleaning',
      'Paw pads trimming',
      'Luxurious bath with premium products',
      'Professional blow dry',
      'Nail trim and grinding',
      'Ear cleaning and inspection',
      'Complementary bandanna or bows',
      'Health assessment during grooming',
    ],
    note: 'Long hair breeds: additional $10',
  },
  {
    key: 'mini-spa',
    name: 'Mini Spa',
    icon: 'Heart',
    gradient: 'from-purple-500 to-pink-400',
    blurb: 'The perfect balance of luxury and essential care between full grooms.',
    includes: [
      'Luxurious bath with premium shampoo',
      'Professional blow dry',
      'Nail trim',
      'Ear cleaning',
      'Face shaping and trimming',
      'Sanitary region cleaning',
      'Paw pads trimming',
      'Complementary bandanna or bows',
      'Basic brush out',
    ],
    note: 'Long hair breeds: additional $10',
  },
  {
    key: 'luxurious-bath',
    name: 'Luxurious Bath',
    icon: 'Bath',
    gradient: 'from-cyan-500 to-blue-400',
    blurb: 'A relaxing, refreshing bath experience with premium products and a full brush out.',
    includes: [
      'Relaxing bath with premium products',
      'Professional blow dry',
      'Thorough brush out',
      'Ear cleaning',
      'Nail trim',
      'Complementary bandanna and bows',
      'Basic health check during service',
    ],
    note: 'Long hair breeds: additional $10',
  },
  {
    key: 'kitty-services',
    name: 'Kitty Services',
    icon: 'Cat',
    gradient: 'from-orange-400 to-amber-400',
    blurb: 'Specialised grooming for feline friends — cat-safe products, gentle handling, zero stress.',
    includes: [
      'All over grooming with gentle techniques',
      'Brazilian sanitary regions cleaning',
      'Luxurious bath with cat-safe products',
      'Gentle blow dry (if tolerated)',
      'Ear cleaning with special care',
      'Nail trim',
      'Complementary bandanna or bow tie',
      'Stress-free environment',
    ],
    note: 'Kitty Full Spa and Kitty Mini Spa available',
  },
  {
    key: 'add-ons',
    name: 'Happy Tail Add-Ons',
    icon: 'Plus',
    gradient: 'from-emerald-400 to-cyan-400',
    blurb: 'Premium extras to make any visit special — facials, massages, treatments and more.',
    includes: [
      'Nail grind',
      'Blueberry facial',
      'Therapeutic massage',
      'Teeth, glands and facial',
      'Flea treatment',
      'Medicated / whitening shampoo',
      'Conditioner treatment',
      'De-shedding treatment',
      'Hair dying',
      'Special handling for pets with special needs',
    ],
    note: 'Add-ons combine with any main service',
  },
  {
    key: 'bonuses',
    name: 'Bow-WOW Bonuses',
    icon: 'Gift',
    gradient: 'from-fuchsia-500 to-purple-400',
    blurb: 'Celebration packages — birthdays, gotcha days and extra pampering for good pups.',
    includes: [
      'King or Queen Birthday Package',
      'Birthday bandanna and specialty treat',
      'Groom and Bloom Package',
      'Teeth brushing',
      'Gland expression',
      'Nail painting and styled paws',
      'Face trim and ear plucking',
      'Special celebration photos',
    ],
    note: 'Ask us about combining packages',
  },
];

// No REVIEWS / STATS here on purpose. The launch site carries no ratings,
// review counts or "happy pets" figures until there are real ones to publish.

// Real photos only — the petcare-* illustrations clash with photography in the ribbons.
export const GALLERY = [
  { src: '/pexels-goochie-poochie-19145889.webp', alt: 'Freshly groomed dog at Bubbles & Bark' },
  { src: '/pexels-mikhail-nilov-7470635.webp', alt: 'Dog enjoying a luxurious bath' },
  { src: '/pexels-roman-odintsov-6342013.webp', alt: 'Professional grooming session' },
  { src: '/pexels-tima-miroshnichenko-6130976.webp', alt: 'Happy pet after spa day' },
];
